{
  "id": "campaign-059",
  "name": "Neglected Field II",
  "seed": "campaign:59",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "RRRRRR,,,,,,",
    "RRRRRR,,,,,,",
    "______,,,,,,",
    ",...,x,,,,,,",
    ",y,,y,,y,,y,",
    ",,,,,,,,,,,,",
    ",,u,T,,T,u,,",
    ",,~,,,,,,,,,",
    "fffff,,fffff",
    "..~.,,,,,,,,",
    ".....,,#,,,,",
    ".....,,,,,,,",
    "f..fffffffff",
    ",c.c.cc,c,c,",
    ",~....,,,,,,",
    ",~~.T.,T,,#,",
    ".....,,,,,,,",
    "S...,,,,,,,,"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 4,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 2,
      "y": 12
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 11,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 8,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 1
    }
  ],
  "generatorVersion": 3,
  "level": 59,
  "biome": "farm",
  "par": {
    "reel": 17358,
    "push": 10700,
    "selfPropelled": 9606,
    "tractor": 5661,
    "zeroTurn": 6478,
    "fairway": 4160
  },
  "routeTries": {
    "par": {
      "reel": 14,
      "push": 23,
      "selfPropelled": 14,
      "tractor": 2,
      "zeroTurn": 24,
      "fairway": 7
    }
  }
}
